import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomCursor from '../components/CustomCursor';
import './EntryPage.css';
import logoImage from '../images/skullture_white.png';
import heroImage from '../images/image1.png';
import { 
  playBillSound, 
  playSuccessSound, 
  playErrorSound, 
  playUnlockSound,
  playPageLoadSound,
  playThunderSound,
  stopLoadingSound
} from '../utils/soundEffects';

const EntryPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Create particles
    for(let i = 0; i < 50; i++) {
      const particle = document.createElement('div');
      particle.classList.add('particle');
      particle.style.left = Math.random() * 100 + '%';
      particle.style.animationDelay = Math.random() * 8 + 's';
      particle.style.animationDuration = 5 + Math.random() * 5 + 's';
      particle.style.width = Math.random() * 3 + 1 + 'px';
      particle.style.height = particle.style.width;
      document.body.appendChild(particle);
    }
    
    return () => {
      document.querySelectorAll('.particle').forEach(p => p.remove());
    };
  }, []);

  const handleRequestAccess = () => {
    playBillSound();
    navigate('/login');
  };

  return (
    <div className="entry-page">
      <CustomCursor />
      <div className="auth-card">
        <div className="glitch-text">
           <img src={logoImage} alt="SKULLTURE"
            onError={(e) => {
              e.target.style.display = 'none';
              const parent = e.target.parentElement;
              const span = document.createElement('span');
              span.className = 'logo-text-fallback';
              span.textContent = 'SKULLTURE';
              parent.insertBefore(span, e.target);
            }}
          />
        </div>
        <div className="auth-title">CLASSIFIED ARCHIVE</div>
        <div className="auth-sub">RESTRICTED ACCESS PROTOCOL</div>
        <div className="divider"></div>
        <div className="entry-text">
          Identity verification required.<br />
          Initiation protocol active.
        </div>
        <button className="auth-btn" onClick={handleRequestAccess}>
          ⟡ REQUEST ACCESS ⟡
        </button>

        <div className="demo-text">UNAUTHORIZED ACCESS PROHIBITED</div>
      </div>
    </div>
  );
};

export default EntryPage;